import { NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SETTINGS_NAV, allowed } from "@/components/layout/AppShell";

export const SettingsTabs = () => {
  const { user } = useAuth();
  return (
    <div className="flex flex-wrap gap-2 mb-6" data-testid="settings-tabs">
      {allowed(user, SETTINGS_NAV).map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          data-testid={`settings-tab-${label.toLowerCase()}`}
          className={({ isActive }) =>
            `flex items-center gap-2 px-4 py-2 rounded-full border text-sm transition-colors ${
              isActive ? "bg-[#24474A] text-white border-[#24474A] font-bold" : "bg-white text-slate-600 border-slate-200 hover:border-[#24474A]/40"
            }`
          }
        >
          <Icon className="w-4 h-4" /> {label}
        </NavLink>
      ))}
    </div>
  );
};
